'use client';

import {
  CustomerType,
  type OrderData,
  PageContractConclusionOrderType as PCCOrderType,
  type SELF_SERVICE_REG_TYPE,
  initialContractPartnerPersonalData,
  initialCustomerRecommendationViaCode,
  initialInvoiceAddress,
  initialPaymentData,
  initialPersonalData,
} from './PageContractConclusionTypes';

export const orderData: OrderData = {
  orderType: PCCOrderType.ProviderChange,
  customerType: CustomerType.Individual,
  personalData: initialPersonalData,
  contractPartnerData: initialContractPartnerPersonalData,
  invoiceAddress: initialInvoiceAddress,
  paymentData: initialPaymentData,
  customerRecommendationViaCodeData: initialCustomerRecommendationViaCode,
  incentiveData: {
    code: '',
    value: '0',
    descriptionText: '',
  },
  selfServiceRegistration: 'no_display' as SELF_SERVICE_REG_TYPE,
  optInVisible: false,
  regulatedProducts: '',
  contractData: [],
};

export const descriptions = {
  [PCCOrderType.NewTenant]: 'Ich möchte einen Vertrag für eine neue Lieferadresse abschließen.',
  [PCCOrderType.ProviderChange]: 'Ich ziehe nicht um, und möchte zu den Stadtwerken Düsseldorf wechseln.',
  [PCCOrderType.ProductChange]: 'Ich möchte einen anderen Tarif nutzen. Meine Lieferadresse bleibt unverändert.',
  [PCCOrderType.Retention]: 'Ich möchte Kunde der Stadtwerke Düsseldorf bleiben und einen neuen Vertrag abschließen.',
};

export const labels = {
  [PCCOrderType.NewTenant]: 'Neueinzug',
  [PCCOrderType.ProviderChange]: 'Versorgerwechsel',
  [PCCOrderType.ProductChange]: 'Produktwechsel',
  [PCCOrderType.Retention]: 'Vertragsabschluss',
};

export const getDescription = (orderType: PCCOrderType): string => {
  return descriptions[orderType] ?? '';
};

export const getLabel = (orderType: PCCOrderType): string => {
  return labels[orderType] ?? '';
};
